import React, { createContext, useEffect, useState } from "react";
import { useSelector } from "react-redux";

import { io } from "socket.io-client";

export const socketContext = createContext();

function SocketContext({ children }) {
	const [socket, setSocket] = useState(null);
	const { token } = useSelector((state) => state.user);

	useEffect(() => {
		if (token) {
			const sck = io(process.env.REACT_APP_API_BASEURL, {
				auth: {
					token,
				},
			});

			setSocket(sck);
		}
	}, [token]);

	return (
		<socketContext.Provider value={socket}>
			{children}
		</socketContext.Provider>
	);
}

export default SocketContext;
